<template>
    <div class="visit-summary">
        <h1>Your visit</h1>
        <table>
            <tr>
                <td>House</td>
                <td colspan="2">
                    <div v-if="!submitted || house_slug === 'arbor-house'">
                        <input type="radio" id="arbor" name="house" value="arbor-house" v-model="house_slug" v-if="!submitted" />
                        <label for="arbor">
                            Arbor House
                            <span>(2 BR, 1 BA; sleeps up to 6)</span>
                        </label>
                    </div>
                    <div v-if="!submitted || house_slug === 'storks-nest'">
                        <input type="radio" id="stork" name="house" value="storks-nest" v-model="house_slug" v-if="!submitted" />
                        <label for="stork">
                            Stork's Nest
                            <span>(4 BR, 2 BA; sleeps up to 10)</span>
                        </label>
                    </div>
                </td>
            </tr>
            <tr>
                <td>Check in</td>
                <td
                    :rowspan="showSelectDates ? 2 : false"
                    :style="showSelectDates ? 'vertical-align: middle;' : ''"
                >
                    <span
                        v-if="!house_slug"
                        v-text="'Select a house above'"
                        style="font-style: italic;"
                    />
                    <span
                        v-else-if="dateInString !== ''"
                        v-text="dateInString"
                    />
                    <button
                        v-if="showSelectDates"
                        v-text="'Select dates'"
                        @click="$emit('show-date-chooser')"
                        style="padding: 4px; font-size: 80%;"
                    />
                </td>
                <td rowspan="2" style="text-align: right; vertical-align: middle;">
                    <button
                        class="change-dates-button"
                        v-if="showChangeDates"
                        v-text="'Change dates'"
                        @click="$emit('show-date-chooser')"
                    />
                </td>
            </tr>
            <tr>
                <td>Check out</td>
                <td
                    v-if="!showSelectDates"
                    v-text="dateOutString"
                    :class="{instruction: dateInString && !dateOutString}"
                />
            </tr>
            <tr v-if="discount">
                <td style="padding-top: 15px;">Base rate</td>
                <td style="padding-top: 15px;">
                    <span class="amount">{{ rent ? ('$ ' + rent.toFixed(2)) : '---' }}</span>
                </td>
                <td />
            </tr>
            <tr v-if="discount">
                <td>Discount <span style="font-size: 90%">({{ discountPercent }}%)</span></td>
                <td>
                    <span class="amount">-{{ discount ? ('$ ' + discount.toFixed(2)) : '---' }}</span>
                </td>
                <td />
            </tr>
            <!-- TODO move down? -->
            <tr>
                <td style="padding-top: 15px;">Rent</td>
                <td style="padding-top: 15px;" :class="{'sum-line-above': discount}">
                    <span class="amount">{{ subtotal ? ('$ ' + subtotal.toFixed(2)) : '---' }}</span>
                </td>
                <td />
            </tr>
            <tr v-if="petFee">
                <td>Pet fee</td>
                <td>
                    <span class="amount">{{ petFee ? ('$ ' + petFee.toFixed(2)) : '---' }}</span>
                </td>
                <td />
            </tr>
            <tr>
                <td>Tax</td>
                <td>
                    <span class="amount">{{ tax ? ('$ ' + tax.toFixed(2)) : '---' }}</span>
                </td>
                <td />
            </tr>
            <tr v-if="security">
                <td>Security</td>
                <td>
                    <span class="amount">{{ security ? ('$ ' + security.toFixed(2)) : '---' }}</span>
                </td>
                <td />
            </tr>
            <tr class="total">
                <td>Total</td>
                <td class="sum-line-above">
                    <span class="amount">{{ total ? ('$ ' + total.toFixed(2)) : '---' }}</span>
                </td>
                <td />
            </tr>
        </table>
        <div style="text-align: right; margin-top: 50px;" v-if="!submitted">
<!--
            <button
                v-text="'Clear dates'"
                @click="$emit('clear-dates')"
                :disabled="!(dateInString || dateOutString)"
            />
-->
<!--
            <button
                v-if="showBookNow"
                v-text="'Book now'"
                @click="$emit('book-now')"
                :disabled="!(dateInString && dateOutString)"
            />
-->
        </div>
        <div v-else class="confirmation">
            We have received your reservation request and will be in touch soon!
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import * as calcs from '../../../_modules/reservationCalcs';

export default {
    props: {
        stayDays: {
            type: Array,
        },
        pets: {
            type: Boolean,
            default: false,
        },
        submitted: {
            type: Boolean,
            default: false,
        },
/*
        showBookNow: {
            type: Boolean,
            default: true,
        },
*/
    },

    data() {
        return {
            house_slug: null,
        };
    },
    
    computed: {
        showSelectDates() {
            return (this.stayDays.length === 0 && this.house_slug);
        },

        showChangeDates() {
            return (this.stayDays.length > 0 && !this.submitted);
        },

        dateInString() {
            if (this.stayDays.length === 0) {
                return '';
            }
            return dayjs(this.stayDays[0].date).format('MMM D, YYYY');
        },
        
        dateOutString() {
            if (this.stayDays.length === 0) {
                return '';
            }
            return (this.stayDays.length > 1)
                ? dayjs(this.stayDays[this.stayDays.length - 1].date).add(1, 'day').format('MMM D, YYYY')
                : 'Select check-out date below'
            ;
        },

        rent() {
            return calcs.rent(this.stayDays, this.pets);
        },
        discountPercent() {
            return calcs.discountPercent(this.stayDays, this.pets);
        },
        discount() {
            return calcs.discount(this.stayDays, this.pets);
        },
        petFee() {
            return calcs.petFee(this.stayDays, this.pets);
        },
        subtotal() {
            return calcs.subtotal(this.stayDays, this.pets);
        },
        security() {
            return calcs.security(this.stayDays, this.pets);
        },
        tax() {
            return calcs.tax(this.stayDays, this.pets);
        },
        total() {
            return calcs.total(this.stayDays, this.pets);
        },
    },

    watch: {
        house_slug() {
            this.$emit('house', this.house_slug);
        },
    },

    // methods: {
    //     formatDate(ymd) {
    //         return dayjs(ymd).format('MMM D, YYYY');
    //     },
    // },
}
</script>

<style lang="scss">
.visit-summary {
    * {
        font-family: Verdana, Arial, sans-serif;
    }

    h1 {
        margin-top: 0;
    }

    table {
        width: 100%;
        font-size: 10.5pt;
    }

    td:first-child {
        font-weight: bold;
        padding-right: 15px;
        white-space: nowrap;
    }

    td:nth-child(2) {
        min-width: 6em;
    }

    .instruction {
        font-style: italic;
    }

    .amount {
        display: inline-block;
        width: 6em;
        text-align: right;
    }
    
    .total td {
        padding-top: 5px;
    }
    
    .sum-line-above {
        border-top: 2px solid black;
    }
    label {
        display: inline-block;
        vertical-align: top;
        margin-bottom: 5px;

        span {
            font-size: 70%;
            margin-top: -3px;
            display: block;
        }
    }
    .confirmation {
        margin-top: 30px;
        color: #8A5B0A;
        font-weight: bold;
        text-align: center;
        font-size: 110%;
    }
    .change-dates-button {
        padding: 4px;
        font-size: 80%;

        @media (max-width: 475px) {
            //display: none;
        }
    }
}
</style>
